import Token from '~/api/Token';
import jwt_decode from 'jwt-decode';

class UserInfoService {
    private static getDecodedToken(): any {
        const token = Token.getAccess() as string;
        return jwt_decode(token) as any;
    }
    private static isInRole(decodedToken: any, role: string): boolean {
        if (!!decodedToken.role) {
            if (Array.isArray(decodedToken.role)) {
                const roles = decodedToken.role as string[];
                return roles.find(r => r === role) !== undefined;
            } else {
                if (decodedToken.role === role) {
                    return true;
                }
            }
        }

        return false;
    }

    private static getOrgAdminIdsFromToken(decodedToken: any): number[] {
        const orgAdminMember = decodedToken['org.admin'];

        if (!!orgAdminMember) {
            if (Array.isArray(orgAdminMember)) {
                const ids = orgAdminMember as string[];
                return ids.map(id => +id);
            } else {
                return [+orgAdminMember];
            }
        }

        return [];
    }

    private static getStudentAdminIdsFromToken(decodedToken: Record<string, any>): number[] {
        const studentAdminMember: string | string[] = decodedToken['org.student'];

        if (!!studentAdminMember) {
            if (Array.isArray(studentAdminMember)) {
                const ids = studentAdminMember as string[];
                return ids.map(id => +id);
            } else {
                return [+studentAdminMember];
            }
        }

        return [];
    }

    static isHigheredAdmin(): boolean {
        try {
            const decoded = this.getDecodedToken();
            return this.isInRole(decoded, 'Admin');
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    static isHigheredEmployee(): boolean {
        try {
            const decoded = this.getDecodedToken();
            return this.isInRole(decoded, 'HigherEdEmployee');
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    static getSchoolAdminIds(): number[] {
        try {
            const decoded = this.getDecodedToken();
            return this.getStudentAdminIdsFromToken(decoded);
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    static getOrgAdminIds(): number[] {
        try {
            const decoded = this.getDecodedToken();
            return this.getOrgAdminIdsFromToken(decoded);
        } catch (error) {
            console.log(error);
            return [];
        }
    }
}

export default UserInfoService;
